import { getCookie } from 'lib/cookies';
// import axios from 'axios';
import axiosInstance from 'configs/axiosConfig';

const config = () => {
  return {
    headers: {
      'Authorization': `Bearer ${getCookie('access')}`,
      'Set-Cookie': getCookie('refresh'),
    },
  };
};

// 기본 환경 설정 및 메타태그 설정
export function getConfiguration() {
  return axiosInstance.get(`${process.env.REACT_APP_URI}${process.env.REACT_APP_CONFIG_API}`, config());
}
export function editConfiguration(dataToSubmit) {
  return axiosInstance.post(`${process.env.REACT_APP_URI}${process.env.REACT_APP_CONFIG_API}`, dataToSubmit, config());
}
export function uploadImage(dataToSubmit) {
  return axiosInstance.post(`${process.env.REACT_APP_URI}${process.env.REACT_APP_CONFIG_API}/upload/image`, dataToSubmit, config());
}

// 회원 가입 설정
export function editRegistration(dataToSubmit) {
  return axiosInstance.post(`${process.env.REACT_APP_URI}${process.env.REACT_APP_CONFIG_REGISTER_API}`, dataToSubmit, config());
}

// 특정 환경 설정 불러오기
export function getSpecificConfig(query) {
  return axiosInstance.get(`${process.env.REACT_APP_URI}${process.env.REACT_APP_CONFIG_REGISTER_API}/${query}`, config());
}

// 가입 양식 관리 편집
export function editRegisterForm(dataToSubmit) {
  return axiosInstance.post(`${process.env.REACT_APP_URI}${process.env.REACT_APP_CONFIG_REGISTER_API}/form`, dataToSubmit, config());
}
